import { GDSStyleObject } from '@leagueplatform/genesis-core';

export const NAV_BAR_HEIGHT = 56;
export const RESPONSIVE_NAV_BAR_HEIGHT = 60;
export const MAX_CONTENT_WIDTH = 952;
export const IMAGE_MESSAGE_ICON_WIDTH = 176;

export const SDK_CSS_OVERRIDES: GDSStyleObject = {
  '.badge-progress-wrapper > div > div > div': {
    backgroundColor: '$interactiveActionDisabled',
  },

  '.toast-wrapper': {
    backgroundColor: '$interactiveActionDisabled',
  },

  // OVAT-1842: fix horizontal scrolling for Home / Get Care / About Me
  '.masonry-page-header-background': {
    '&::before': {
      width: '100%',
      insetInlineStart: 0,
    },
  },

  '.cc-page-header-background': {
    '&::before': {
      width: '100%',
      insetInlineStart: 0,
    },
  },
};
